const alignsQueueByAlign = {
  start: ['start', 'end', 'center'],
  end: ['end', 'center', 'start'],
  center: ['center', 'start', 'end'],
  stretch: ['stretch'],
  auto: ['auto']
};
const alignsQueueByDirection = {
  top: ['end', 'center', 'start'],
  bottom: ['start', 'center', 'end'],
  left: ['start', 'center', 'end'],
  right: ['end', 'center', 'start']
};
const oppositeDirections = {
  top: 'bottom',
  left: 'right',
  right: 'left',
  bottom: 'top'
};
export function getAlignsQueue(initialDirection, initialAlign, currentDirection) {
  if (currentDirection === initialDirection || currentDirection === oppositeDirections[initialDirection]) {
    return alignsQueueByAlign[initialAlign];
  }
  return alignsQueueByDirection[initialDirection];
}